import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { hideG5DevicesModal } from '../../actions/ModalActions';
import G5DevicesTabsView from './G5DevicesTabsView';
import './G5DevicesModal.css';

export default function G5DevicesModal() {
  const open = useSelector((state) => state.g5DevicesModal.open);
  const selectedProjectName = useSelector((state) => {
    const { projectsList, selectedProject } = state.leaksList;
    const selectedProjectIndex = projectsList.projectIndexMap[selectedProject];
    return projectsList.items[selectedProjectIndex]?.ShortName || '';
  });
  const dispatch = useDispatch();

  const handleClose = () => dispatch(hideG5DevicesModal());

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      PaperProps={{
        className: 'g5-devices-dialog-paper',
      }}
      aria-labelledby='g5-devices-dialog'
    >
      <Box className='g5-devices-container'>
        {/* top bar for project name and close button */}
        <Box className='g5-devices-topbar'>
          <Typography
            className='g5-devices-project-name'
            variant='h4'
            style={{ paddingLeft: 5 }}
          >
            {selectedProjectName}
          </Typography>
          <IconButton
            onClick={handleClose}
            size='small'
            className='g5-devices-close-button'
          >
            <CloseIcon fontSize='small' />
          </IconButton>
        </Box>
        {/* Main content */}
        <Box className='g5-devices-content'>
          <G5DevicesTabsView location={{ pathname: 'g5Devices' }} />
        </Box>
      </Box>
    </Dialog>
  );
}

G5DevicesModal.propTypes = {
  // no props required
};
